import React from 'react';

const Salesforce = () => (
  <script async src={process.env.SALESFORCE_SRC} type="text/javascript" />
);

export default Salesforce;
